import React, { useEffect, useState } from 'react';
import api from '../api';
import { SystemInfo, AuditEintrag, formatiereBytes, formatiereZeit } from '../types';

const SystemPage: React.FC = () => {
  const [info, setInfo] = useState<SystemInfo | null>(null);
  const [audit, setAudit] = useState<AuditEintrag[]>([]);
  const [fehler, setFehler] = useState('');

  useEffect(() => {
    api
      .get<SystemInfo>('/api/system')
      .then(r => setInfo(r.data))
      .catch(e => setFehler(e.response?.data?.detail || 'System nicht ladbar.'));
    api
      .get<AuditEintrag[]>('/api/audit')
      .then(r => setAudit(r.data))
      .catch(() => {});
  }, []);

  const platte = (p: SystemInfo['kunden']) =>
    `${formatiereBytes(p.frei_bytes)} frei / ${formatiereBytes(p.gesamt_bytes)}`;

  return (
    <div className="k-seite">
      <div className="k-seite__kopf">
        <div>
          <span className="k-eyebrow">{'// fleet / system'}</span>
          <h1 className="k-h1">System</h1>
        </div>
      </div>

      {fehler && <div className="k-fehler">{fehler}</div>}

      {info && (
        <dl className="k-fakten">
          <div className="k-fakt">
            <dt>Fleet-Version</dt>
            <dd className="k-mono">{info.version}</dd>
          </div>
          <div className="k-fakt">
            <dt>{info.kunden.pfad}</dt>
            <dd className="k-mono">{platte(info.kunden)}</dd>
          </div>
          <div className="k-fakt">
            <dt>{info.backups.pfad}</dt>
            <dd className="k-mono">{platte(info.backups)}</dd>
          </div>
        </dl>
      )}

      <h2 className="k-h2">Audit-Log ({audit.length})</h2>
      <div className="k-tabelle__rahmen">
        <table className="k-tabelle">
          <thead>
            <tr>
              <th>Zeitpunkt</th>
              <th>Benutzer</th>
              <th>Aktion</th>
              <th>Ziel</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {audit.map(e => (
              <tr key={e.id}>
                <td className="k-mono">{formatiereZeit(e.zeitpunkt)}</td>
                <td className="k-mono">{e.benutzer_email || '—'}</td>
                <td>{e.aktion}</td>
                <td className="k-mono">{[e.ziel_typ, e.ziel_id].filter(Boolean).join(' ') || '—'}</td>
                <td className="k-mono">{e.details || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SystemPage;
